import axios from 'axios';

// Fixed — points to Railway backend directly
// REACT_APP_API_URL can override via Vercel env vars
const BASE = 'https://gridmind-production-3fdb.up.railway.app';
const simulate = {
  gridLoad: () => parseFloat((2.8 + Math.random() * 0.8).toFixed(2)),
  solar: () => Math.round(1400 + Math.random() * 600),
  wind: () => Math.round(600 + Math.random() * 300),
  carbon: () => Math.round(36 + Math.random() * 14),
  forecast72: () => Array.from({ length: 72 }, (_, i) => {
    const h = i % 24; const day = Math.floor(i / 24);
    const base = 2.8 + Math.sin((h - 6) * Math.PI / 12) * 1.1 + day * 0.12;
    return { hour: i, value: parseFloat((base + Math.random() * 0.2).toFixed(2)) };
  }),
  // No fabricated incidents — an unreachable backend means "no fault data",
  // not invented events. See Dashboard.js / OtherPages.js for the empty state.
  faults: () => [],
  zones: () => [
    { name: 'Northern',   region: 'UP/Delhi',      load: 0.82, capacity: 1.2, status: 'normal' },
    { name: 'Western',    region: 'MH/GJ',          load: 0.94, capacity: 1.1, status: 'warn'   },
    { name: 'Southern',   region: 'TN/KA',          load: 0.71, capacity: 1.0, status: 'normal' },
    { name: 'Eastern',    region: 'WB/OD',          load: 0.58, capacity: 0.9, status: 'normal' },
    { name: 'North-East', region: 'AS/Other',       load: 0.31, capacity: 0.6, status: 'normal' },
    { name: 'Central',    region: 'MP/CG',          load: 0.46, capacity: 0.8, status: 'normal' },
    { name: 'Rajasthan',  region: 'RJ',             load: 0.41, capacity: 0.6, status: 'normal' },
    { name: 'Mumbai',     region: 'Mumbai Metro',   load: 0.89, capacity: 1.0, status: 'alert'  },
  ],
};

async function fetchWithFallback(endpoint, fallbackFn) {
  try {
    const res = await axios.get(`${BASE}${endpoint}`, { timeout: 6000 });
    return { data: res.data, source: 'live' };
  } catch (e) {
    console.warn(`GridMind API fallback for ${endpoint}:`, e.message);
    return { data: fallbackFn(), source: 'simulated' };
  }
}

export const api = {
  getLiveGrid: () => fetchWithFallback('/api/grid/live', () => ({
    load: simulate.gridLoad(),
    solar: simulate.solar(),
    wind: simulate.wind(),
    carbon: simulate.carbon(),
    temperature: 32,
    radiation: 0,
    windspeed: 12,
    accuracy: 99.2,
    source: 'simulated',
    timestamp: new Date().toISOString(),
    location: 'India',
  })),

  getForecast: (hours = 72) => fetchWithFallback(
    `/api/forecast?hours=${hours}`,
    () => simulate.forecast72().slice(0, hours)
  ),

  getFaults:    () => fetchWithFallback('/api/faults',    simulate.faults),
  getZones:     () => fetchWithFallback('/api/zones',     simulate.zones),
  getStates:    () => fetchWithFallback('/api/states',    () => ({})),

  getEnergyMix: () => fetchWithFallback('/api/grid/mix', () => ({
    solar: 54, wind: 26, hydro: 12, thermal: 8
  })),

  getMLForecast: () => fetchWithFallback('/api/ml/forecast', () => ({
    demand: [], solar: []
  })),

  askAdvisor: async (question, history = [], state = 'UP') => {
    try {
      const res = await axios.post(
        `${BASE}/api/advisor`,
        { question, history, state },
        { timeout: 12000 }
      );
      return res.data.answer;
    } catch (e) {
      console.warn('Advisor fallback:', e.message);
      const q = question.toLowerCase();
      if (q.includes('ac') || q.includes('tonight'))
        return 'Best tariff window tonight is 1-4 AM at Rs 2.10/kWh. Running your 1.5 ton AC saves Rs 22 vs peak hours.';
      if (q.includes('solar'))
        return 'Solar output depends on current radiation levels. Check the dashboard for real-time solar data.';
      if (q.includes('bill') || q.includes('save') || q.includes('reduce'))
        return 'Top savings: (1) Shift appliances to 1-4 AM — Rs 180/mo. (2) AC at 26°C — Rs 340/mo. (3) Community solar — Rs 420/mo.';
      if (q.includes('tariff') || q.includes('rate'))
        return 'UP DISCOM: Peak Rs 6.50/kWh. Off-peak Rs 3.20/kWh. Tonight cheapest: Rs 2.10/kWh at 1-4 AM.';
      return 'Your usage today is 18.4 kWh — 12% below monthly average. Solar contributing 34%. Found 3 optimisation opportunities saving Rs 1,200 this month.';
    }
  }
};